import { useQuery } from '@tanstack/react-query';
import { APP_CONFIG } from '../config';

const DEFAULT_DEPLOYMENT_INFO = {
  hostname: 'N/A',
  environment: 'N/A',
  region: 'N/A'
};

const fetchHostInfo = async () => {
  const response = await fetch(`${APP_CONFIG.API_BASE_URL}/host-info`);
  if (!response.ok) {
    throw new Error('Failed to fetch host info');
  }
  const data = await response.json();
  
  // Map the host-info response format
  return {
    hostname: data.hostname || 'N/A',
    environment: data.environment || 'N/A',
    region: data.region || 'N/A',
    startedAt: data.startedAt,
    platform: data.platform,
    nodeVersion: data.nodeVersion,
    uptime: data.uptime
  };
};

export function useDeploymentInfo() {
  const { data: deploymentInfo } = useQuery({
    queryKey: ['hostInfo'],
    queryFn: fetchHostInfo,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    cacheTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    retry: 1,
    refetchOnWindowFocus: false,
    placeholderData: DEFAULT_DEPLOYMENT_INFO
  });

  return deploymentInfo;
}